import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useAddDispatch } from "../../store";
import { GetListValue } from "./commonSlice";

export const getStatus = createAsyncThunk('auth/getStatus', async (companyCode: any, thunkAPI: any) => {
    try {
        const response = (await thunkAPI.dispatch(GetListValue({ ControlName: "statusmaster", CompanyCode: companyCode }))).payload;
        return response;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});

export const statusMasterSlice = createSlice({
    name: "statusMasterSlice",
    initialState: {
        status: null,
        isLoading: false,
        error: null,
    },
    reducers: {
        UpdatestatusMasterData: (intialState: any, action: any) => {
            return {
                ...intialState,
                status: action?.payload
            };
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getStatus.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload?.isSuccess) {
                    state.status = action.payload.result;
                }
                else {
                    state.status = null;
                    state.error = action.payload.resultMessage;
                }
            })
            .addCase(getStatus.rejected, (state: any, action: any) => {
                state.isLoading = false;
                state.error = action.payload?.resultMessage;
            });
    },
});

export const { UpdatestatusMasterData } = statusMasterSlice.actions;
export default statusMasterSlice.reducer;